<template>
  <f7-popup id="popup-booking" class="popup-booking" swipe-to-close push>
    <f7-view>
      <f7-page>
        <f7-navbar no-hairline>
          <f7-nav-left>
            <span class="popup-profile-title">
              {{ $t(`booking.title`) }}
            </span>
          </f7-nav-left>

          <f7-nav-right>
            <f7-link
              icon-f7="close"
              icon-color="gray"
              @click="$f7.popup.close()"
            ></f7-link>
          </f7-nav-right>
        </f7-navbar>

        <f7-block v-show="loadAvailableBookingDates" class="loading-data">
          <f7-preloader size="30" color="black"></f7-preloader>
        </f7-block>

        <div v-show="!loadAvailableBookingDates" class="page-content-inner">
          <f7-block class="no-padding">
            <f7-block
              v-if="updateAvailableBookingDates"
              class="loading-data loading-booking-calendar"
            >
              <f7-preloader size="30" color="black"></f7-preloader>
            </f7-block>
            <div id="booking-calendar"></div>
          </f7-block>

          <f7-swiper
            v-if="availableBookingTimes"
            :params="sliderOption"
            class="select-slider select-slider--booking margin-bottom"
          >
            <f7-swiper-slide
              v-for="(time, index) in availableBookingTimes"
              :key="index"
            >
              <f7-button
                fill
                large
                :class="[
                  'select-slider-button',
                  {
                    'select-slider-button--active gradient':
                      selected.time === time
                  }
                ]"
                :color="selected.time === time ? 'pink' : 'white'"
                @click="selected.time = time"
              >
                {{
                  `c ${format(new Date(time.start), 'HH:mm')} до ${format(
                    new Date(time.end),
                    'HH:mm'
                  )}`
                }}
              </f7-button>
            </f7-swiper-slide>
          </f7-swiper>

          <f7-block class=" mt-auto margin-bottom popup-booking-teacher-id">
            <f7-list class="popup-auth-list no-margin-vertical">
              <f7-list-input
                type="text"
                floating-label
                clear-button
                :placeholder="$t(`teacher_id`)"
                :value="teacherId"
                @input="teacherId = $event.target.value"
              ></f7-list-input>
            </f7-list>

            <f7-button
              class="gradient"
              fill
              large
              @click="updateAvailableBookingDatesPerMonth"
            >
              {{ $t(`booking.update_calendar`) }}
            </f7-button>
          </f7-block>

          <f7-block class="margin-top">
            <f7-button
              fill
              large
              class="display-flex justify-content-space-between gradient"
              @click="toBook"
            >
              {{ $t(`booking.to_book`) }}
              <f7-preloader v-if="loading" color="white"></f7-preloader>
              <f7-icon
                v-else
                f7="arrow_right"
                color="white"
                size="24"
              ></f7-icon>
            </f7-button>
          </f7-block>
        </div>
      </f7-page>
    </f7-view>
  </f7-popup>
</template>

<script>
import { format, addMonths, isSameMonth, isPast, isSameDay } from 'date-fns';
import apiRequest from '@/js/helpers/apiRequest.js';
import notify from '@/js/helpers/notify.js';

export default {
  name: 'PopupBooking',

  data() {
    return {
      sliderOption: {
        slidesPerView: 'auto',
        freeMode: true
      },
      loadAvailableBookingDates: false,
      updateAvailableBookingDates: false,
      teacherId: '',
      availableBookingDates: [],
      availableBookingDays: [],
      availableBookingTimes: [],
      selected: {
        date: '',
        time: {}
      },
      loading: false
    };
  },

  computed: {
    format: () => format
  },

  async mounted() {
    this.createCalendar();

    this.loadAvailableBookingDates = true;
    await this.getAvailableBookingDatesPerMonth();
    this.loadAvailableBookingDates = false;
  },

  methods: {
    async getAvailableBookingDatesPerMonth() {
      const date = new Date();
      const start = format(date, 'dd.MM.yyyy');
      const end = format(addMonths(date, 1), 'dd.MM.yyyy');
      const teacherId = this.teacherId ? `/${this.teacherId}` : '';
      const levelId = this.$store.state.selectLevel;
      const languageId = this.$store.state.selectLanguageId;

      try {
        const res = await apiRequest(
          `booking${teacherId}?start=${start}&end=${end}&level_id=${levelId}&language_id=${languageId}`,
          'GET',
          null,
          true
        );

        if (res.error) {
          notify({ text: res.error });
          return;
        }

        if (
          Object.entries(res.success).filter((item) => item[1] === null)
            .length === Object.entries(res.success).length
        ) {
          return;
        }

        this.availableBookingDates = Object.entries(res.success)
          .map(
            ([key, value]) =>
              value && { [format(new Date(key), 'yyyy/MM/dd')]: value }
          )
          .filter((item) => item);

        this.availableBookingDays = this.availableBookingDates.map((object) => {
          return {
            date: Object.keys(object)[0],
            color: '#ff6189'
          };
        });

        this.calendar.setValue(
          this.availableBookingDates &&
            Object.keys(this.availableBookingDates[0])
        );
        this.renderAvailableBookingDays(this.availableBookingDays);
      } catch (error) {
        notify({ text: this.$t(`notify.something_went_wrong`) });
      }
    },

    async updateAvailableBookingDatesPerMonth() {
      this.updateAvailableBookingDates = true;
      this.availableBookingTimes = [];
      await this.getAvailableBookingDatesPerMonth();
      this.updateAvailableBookingDates = false;
    },

    renderAvailableBookingDays(days = []) {
      this.calendar.params.events = days;
      this.calendar.update();
    },

    renderAvailableBookingTimesByDay(date) {
      const selectedDate = format(new Date(date), 'yyyy/MM/dd');
      const arrayOfTimesPeriods = this.availableBookingDates.filter(
        (object) => Object.keys(object)[0] === selectedDate
      );

      if (!arrayOfTimesPeriods.length) {
        this.availableBookingTimes = [];
        return;
      }

      const availableTimes = arrayOfTimesPeriods[0][selectedDate].map(
        (time) => ({
          start: time.start,
          end: time.end
        })
      );

      this.availableBookingTimes = availableTimes;
      this.selected.time =
        this.availableBookingTimes && this.availableBookingTimes[0];
    },

    createCalendar() {
      this.calendar = this.$f7.calendar.create({
        containerEl: '#booking-calendar',
        monthPicker: false,
        monthSelector: false,
        yeadPicker: false,
        yearSelector: false,
        dateFormat: 'yyyy.mm.dd',
        locale: this.$i18n.locale,
        disabled: (date) =>
          isPast(new Date(date)) &&
          !(isSameDay(date, new Date()) && isSameMonth(date, new Date())),
        on: {
          change: (calendar, value) => {
            this.selected.date = value[0];
            this.selected.time = {};
            this.renderAvailableBookingTimesByDay(value[0]);
          }
        }
      });

      this.$once('hook:beforeDestroy', () => {
        this.calendar.destroy();
        this.calendar = null;
      });
    },

    async toBook() {
      const {
        selected: {
          time: { start, end }
        }
      } = this;

      if (!start && !end) {
        notify({ text: this.$t(`booking.choose_date_and_time`) });
        return;
      }

      const levelId = this.$store.state.selectLevel;
      const languageId = this.$store.state.selectLanguageId;
      const teacherId = this.teacherId ? `/${this.teacherId}` : '';
      const body = new FormData();

      body.append('start', format(new Date(start), 'yyyy-MM-dd HH:mm xx'));
      body.append('end', format(new Date(end), 'yyyy-MM-dd HH:mm xx'));
      body.append('level_id', levelId);
      body.append('language_id', languageId);

      try {
        this.loading = true;
        const res = await apiRequest(`booking${teacherId}`, 'POST', body, true);
        this.loading = false;

        if (res.error) {
          notify({ text: res.error });
          return;
        }

        await this.$store.dispatch('user/getUserInfo');
        notify({ text: res.success });
        this.$f7.popup.close();
      } catch (error) {
        notify({ text: this.$t(`notify.something_went_wrong`) });
      }
    }
  }
};
</script>

<style lang="less">
.popup-booking {
  .toolbar.toolbar-top {
    display: none;
  }

  .swiper-container {
    margin-right: 0;
    margin-left: 0;
  }
}

.loading-booking-calendar {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(#ffffff, 0.5);
}

.popup-booking-teacher-id {
  display: flex;
  align-items: center;

  .popup-auth-list {
    flex-basis: 50%;
    ul {
      &::before {
        display: none;
      }
    }
  }

  a {
    margin-left: 20px;
    flex-basis: 50%;
  }
}
</style>
